import { api } from '@/utils/api'

import { ApiResponseHandler, Gettable } from './ApiInterfaces'
import { ApiBase, ResponseError } from './ApiBase'

/**
 * 実力テスト志望校別成績取得（志望校合格力診断）
 */
export namespace ApiTaRe310 {
  export const name: string = 'ApiTaRe310'

  // GET parameters
  export namespace Get {
    export const path: string = '/ta/getAspiringschoolpassingabilitydiagnosis'

    export interface Request {
      query: {
        fiscalYear: number
        testMonth: number
        testCountPerMonth?: number
        grade: number
        courseId: string
      }
    }

    // API Response
    export interface Response {
      abilityTestReport: {
        scoreList: {
          subjectCode: string
          score: string
        }[]
        choiceSchoolScoreList: {
          choiceSchoolName: string
          averageList: {
            subjectCode: string
            averageScore: string
          }[]
          judgmentSubjectList: {
            subjectForJudgement: string
            judgment: string
            comment: string
          }[]
          choiceSchoolRemark: string
        }[]
      }
    }
  }

  // API本体
  export class Api extends ApiBase implements Gettable<Get.Request, Get.Response, ResponseError> {
    // GET
    public get<R>(
      params: Get.Request,
      successHandler: ApiResponseHandler<Get.Response, R>,
      errorHandler: ApiResponseHandler<ResponseError, R>
    ): Promise<R | null> {
      // 成功時のレスポンス構造サンプル
      const validationSample: Get.Response = {
        abilityTestReport: {
          scoreList: [
            {
              subjectCode: '',
              score: '',
            },
          ],
          choiceSchoolScoreList: [
            {
              choiceSchoolName: '',
              averageList: [
                {
                  subjectCode: '',
                  averageScore: '',
                },
              ],
              judgmentSubjectList: [
                {
                  subjectForJudgement: '',
                  judgment: '',
                  comment: '',
                },
              ],
              choiceSchoolRemark: '',
            },
          ],
        },
      }
      // エラー時のレスポンス構造
      const validationErrorSample: ResponseError = {
        error: {
          messageId: '',
          message: '',
        },
      }

      // API呼び出し
      return this.callbackWrapper<Get.Response, ResponseError, R>(
        api.get<Get.Response>(Get.path, { params: params.query }),
        successHandler,
        errorHandler,
        validationSample,
        validationErrorSample
      )
    }
  }
}
